import { identity } from 'lodash/fp';

const DEFAULT_LIMITATION_COUNT = 10;

export default function searchable(searchCall: $TSFixMe, onSuccess = identity) {
    return {
        search(
            profileId: $TSFixMe,
            enterpriseId: $TSFixMe,
            searchToken: $TSFixMe,
            { startIndex = 0, count = DEFAULT_LIMITATION_COUNT } = {},
            optionalParams = {}
        ) {
            return searchCall({
                enterpriseId,
                searchToken,
                profileId,
                count,
                startIndex: startIndex * count,
                ...optionalParams,
            }).then(onSuccess);
        },
    };
}
